<template>
  <div id="wrapper">
    <Nav :message="message" />
    <Invoice />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import Invoice from '@/components/revenue/Invoice.vue'

export default {
  name: 'InvoiceManagement',
  props: ['message'],
  components: {
    Nav,
    Invoice
  }
}
</script>